"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _HintMark = _interopRequireDefault(require("../materials/HintMark"));
var _TitleHelpMark = _interopRequireDefault(require("../materials/TitleHelpMark"));
var _SafeGrid = _interopRequireDefault(require("../materials/SafeGrid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const LINE_BASE = 4;
const HEADER_HEIGHT_UNITS = 2;
const HEADER_RIGHT_PADDING_UNITS = 1;
const TITLE_MARGIN_UNITS = 1;
const SUBTITLE_MARGIN_UNITS = 2;
const ACTION_ITEM_MARGIN_UNITS = 2;
const EXPAND_ICON_LEFT = 5;
const TRANSITION_SEC = '0.5s';
const SUBTITLE_COLOR = 'yellow';
const HINT_ICON_COLOR = 'white';
const StyledSummary = (0, _styles.styled)(_material.AccordionSummary, {
  shouldForwardProp: prop => prop !== 'lines'
})(_ref => {
  var _theme$palette$cardHe;
  let {
    theme,
    lines = 1
  } = _ref;
  return {
    background: (_theme$palette$cardHe = theme.palette.cardHeader) === null || _theme$palette$cardHe === void 0 ? void 0 : _theme$palette$cardHe.main,
    height: theme.spacing(HEADER_HEIGHT_UNITS),
    paddingRight: theme.spacing(HEADER_RIGHT_PADDING_UNITS),
    minHeight: theme.spacing(lines * LINE_BASE),
    '& .MuiAccordionSummary-content': {
      width: '100%'
    },
    '&.Mui-expanded': {
      minHeight: theme.spacing(lines * LINE_BASE)
    }
  };
});
const ExpandIcon = (0, _styles.styled)(_ExpandMore.default, {
  shouldForwardProp: prop => prop !== 'open'
})(_ref2 => {
  let {
    open
  } = _ref2;
  return {
    position: 'absolute',
    left: EXPAND_ICON_LEFT,
    transition: "transform ".concat(TRANSITION_SEC),
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
  };
});
const StyledDetails = (0, _styles.styled)(_material.AccordionDetails)({
  display: 'block'
});
const TitleText = (0, _styles.styled)(_material.Typography)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    marginLeft: theme.spacing(TITLE_MARGIN_UNITS),
    fontSize: theme.typography.body2.fontSize
  };
});
const SubTitleText = (0, _styles.styled)(_material.Typography)(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    marginLeft: theme.spacing(SUBTITLE_MARGIN_UNITS),
    color: SUBTITLE_COLOR,
    fontSize: theme.typography.body2.fontSize
  };
});
const HelpIcon = (0, _styles.styled)(_TitleHelpMark.default)({
  paddingTop: '4px',
  paddingBottom: '4px'
});
const ButtonWrapper = (0, _styles.styled)(_material.Typography)({
  margin: '0 0 0 auto',
  whiteSpace: 'nowrap'
});
const ActionItem = (0, _styles.styled)('div')(_ref5 => {
  let {
    theme
  } = _ref5;
  return {
    marginLeft: theme.spacing(ACTION_ITEM_MARGIN_UNITS),
    display: 'inline-flex',
    alignItems: 'center'
  };
});
const TitleArea = (0, _styles.styled)('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  '&:last-child': {
    paddingRight: 0
  }
});
const HintIcon = (0, _styles.styled)(_HintMark.default)({
  color: HINT_ICON_COLOR
});

/**
 * @classdesc アコーディオン部品
 * @prop {string} title - タイトル
 * @prop {node} [help] - 表示する業務マニュアルの内容
 * @prop {string} [subTitle] - サブタイトル
 * @prop {boolean} [defaultExpanded=true] - 初期開閉状態
 * @prop {node} children - コンポーネント
 * @prop {array} [buttons] - ボタン
 * @prop {func} [expandAction] - 開閉アクション時に独自処理を行う場合に指定する<br/>
 * @prop {bool} [lineDouble] - 2行で表示指定<br/>
 * @prop {bool} [lineTriple] - 3行で表示指定<br/>
 * シグネチャ: (expanded: bool):void
 *
 */
class Accordion extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleClick", (e, expanded) => {
      if (e.target.id) {
        this.setState({
          expanded
        });
      }
    });
    _defineProperty(this, "iconClick", e => {
      this.setState({
        expanded: !this.state.expanded
      });
      e.stopPropagation();
    });
    _defineProperty(this, "titleRenderer", () => {
      const {
        title,
        help,
        hint
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ExpandIcon, {
        id: "icon",
        color: "primary",
        open: this.state.expanded,
        onClick: this.iconClick
      }), /*#__PURE__*/_react.default.createElement(TitleText, {
        id: "title",
        color: "text.secondary",
        noWrap: true
      }, title), help && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(HelpIcon, {
        help: help
      })), hint && /*#__PURE__*/_react.default.createElement(HintIcon, {
        hint: hint
      }));
    });
    _defineProperty(this, "subTitleRenderer", () => {
      const {
        subTitle
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, subTitle && /*#__PURE__*/_react.default.createElement(SubTitleText, {
        id: "subTitle",
        color: "text.secondary",
        noWrap: true
      }, subTitle));
    });
    _defineProperty(this, "buttonRenderer", () => {
      const {
        buttons
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttons && /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, buttons.map((item, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: 'accordion_btn' + index
      }, item))));
    });
    this.state = {
      expanded: props.defaultExpanded
    };
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      expandAction
    } = this.props;
    if (expandAction && prevState.expanded !== this.state.expanded) {
      expandAction(this.state.expanded);
    }
  }
  render() {
    const {
      className,
      children,
      actions,
      lineDouble,
      lineTriple
    } = this.props;
    const lines = lineTriple ? 3 : lineDouble ? 2 : 1;
    return /*#__PURE__*/_react.default.createElement(_material.Accordion, {
      expanded: this.state.expanded,
      onChange: this.handleClick,
      className: className
    }, /*#__PURE__*/_react.default.createElement(StyledSummary, {
      id: "panel",
      lines: lines,
      component: "div"
    }, lineTriple ? /*#__PURE__*/_react.default.createElement(_SafeGrid.default, {
      container: true,
      style: {
        width: '100%',
        paddingRight: 0
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(TitleArea, {
      id: "titleArea"
    }, this.titleRenderer())), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(TitleArea, {
      id: "titleArea"
    }, this.subTitleRenderer())), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(TitleArea, {
      id: "titleArea"
    }, this.buttonRenderer()))) : lineDouble ? /*#__PURE__*/_react.default.createElement(_SafeGrid.default, {
      container: true,
      style: {
        width: '100%',
        paddingRight: 0
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(TitleArea, {
      id: "titleArea"
    }, this.titleRenderer())), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(TitleArea, {
      id: "titleArea"
    }, this.subTitleRenderer(), this.buttonRenderer()))) : /*#__PURE__*/_react.default.createElement(TitleArea, {
      id: "titleArea"
    }, this.titleRenderer(), this.subTitleRenderer(), this.buttonRenderer())), /*#__PURE__*/_react.default.createElement(StyledDetails, null, children), Array.isArray(actions) && actions.length > 0 && /*#__PURE__*/_react.default.createElement(_material.AccordionActions, null, actions.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement(ActionItem, {
        key: 'accordion' + index
      }, item || null);
    })));
  }
}
Accordion.propTypes = {
  title: _propTypes.default.string,
  help: _propTypes.default.node,
  subTitle: _propTypes.default.string,
  defaultExpanded: _propTypes.default.bool,
  children: _propTypes.default.node,
  buttons: _propTypes.default.array,
  expandAction: _propTypes.default.func,
  lineDouble: _propTypes.default.bool,
  lineTriple: _propTypes.default.bool
};
Accordion.defaultProps = {
  defaultExpanded: true
};
var _default = exports.default = Accordion;